export enum BatchDownloadClientMethodNames {
    RecordingChangedNotification = "RecordingChangedNotification",
    JobChangedNotification = "JobChangedNotification",
}

export const batchDownloadGroupId = "batchdownload";
export const batchDownloadClientMethodNames = [
    BatchDownloadClientMethodNames.RecordingChangedNotification,
    BatchDownloadClientMethodNames.JobChangedNotification,
];
